
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["anfix_svg svg_icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.73 58.4"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"data-name":"Capa 1"}},[_c('path',{attrs:{"d":"M9.65 58.38a10.36 10.36 0 01-8.94-6.22c-1.44-3.54-.68-6.9 2.23-9.81 2.26-2.26 4.53-4.5 6.78-6.77a8.63 8.63 0 000-12.77c-2.31-2.32-4.64-4.61-6.94-6.94-3.69-3.72-3.66-8.8 0-12.56A9.59 9.59 0 018.35.1a8.46 8.46 0 017.44 2.43C17.57 4.25 19.3 6 21.05 7.76l34.78 34.62c3.14 3.13 3.86 7.52 1.53 10.89-2.93 4.22-6 5.93-10.64 4.78A9.25 9.25 0 0143 55.86c-2.48-2.25-4.77-4.7-7.16-7.06-3.85-3.81-9-3.83-12.9 0q-3.58 3.52-7.12 7.09a8.16 8.16 0 01-6.17 2.49zM36.68 11.29a11 11 0 0121.9 0 11 11 0 01-21.9 0z"}})])])])
          )
        }
      }
    